import MixIn from '../index'

export default {
  mixins: [MixIn],
  data() {
    return {
      contentTop: 50,
    };
  },
}
